<template>
  <div>
    <div v-if="loading" class="flex justify-center py-10">
      <div
        class="h-10 w-10 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"
        role="status"
        aria-label="Chargement"
      />
    </div>

    <div v-if="error" class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800" role="alert">
      {{ error }}
    </div>

    <div
      v-if="!loading && !error"
      class="staff-stat-hero group relative flex min-h-[160px] items-center overflow-hidden p-5 transition duration-300 ease-out hover:-translate-y-1"
    >
      <div class="pointer-events-none absolute right-4 top-2 h-40 w-40 opacity-[0.12]">
        <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" class="h-full w-full" aria-hidden="true">
          <defs>
            <linearGradient id="heroGradientStats" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color: var(--brand-navy); stop-opacity: 0.2" />
              <stop offset="100%" style="stop-color: var(--brand-gold); stop-opacity: 0.15" />
            </linearGradient>
          </defs>
          <circle cx="150" cy="150" r="120" fill="url(#heroGradientStats)" />
        </svg>
      </div>
      <div class="relative z-[1] flex w-full items-center justify-between gap-3">
        <div class="min-w-0 flex-1">
          <div class="staff-stat-hero__label mb-1">Analyses totales</div>
          <div class="staff-stat-hero__value text-3xl leading-tight tracking-tight">
            {{ totalAnalyses }}
          </div>
        </div>
        <div class="relative z-[2] shrink-0 opacity-20 transition group-hover:opacity-30">
          <ChartBarIcon class="h-10 w-10" style="color: var(--brand-navy)" aria-hidden="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { ChartBarIcon } from '@heroicons/vue/24/outline';
import { getUserRole, refreshProfileFromApi } from '@/utils/auth';
import { clearAuthenticatedSession, isAuthenticatedSession } from '@/utils/sessionAuth';

export default {
  name: 'StatsCard',
  components: { ChartBarIcon },
  data() {
    return {
      profileRevision: 0,
      totalAnalyses: 0,
      loading: false,
      error: null,
    };
  },
  computed: {
    userRole() {
      void this.profileRevision;
      return getUserRole() || '';
    },
  },
  methods: {
    getValidToken() {
      try {
        return isAuthenticatedSession() ? '1' : null;
      } catch (_) {
        return null;
      }
    },
    async fetchStats() {
      this.loading = true;
      this.error = null;

      try {
        const token = this.getValidToken();
        if (!token) {
          this.error = 'Session invalide ou expirée. Veuillez vous reconnecter.';
          try {
            clearAuthenticatedSession();
          } catch (_) {}
          return;
        }
        let analysesApiUrl = '/api/analyse-patrimoniale/';
        if (
          this.userRole === 'admin' ||
          this.userRole === 'employe' ||
          this.userRole === 'saisie' ||
          this.userRole === 'validation'
        ) {
          analysesApiUrl = '/api/toutes-analyses/';
        }

        const analysesResponse = await axios.get(analysesApiUrl, { withCredentials: true });

        const raw = analysesResponse.data;
        let analysesData = [];
        if (analysesApiUrl.includes('/analyse-patrimoniale/')) {
          if (raw && Array.isArray(raw.analyses)) {
            analysesData = raw.analyses;
          } else if (Array.isArray(raw)) {
            analysesData = raw;
          } else {
            this.error = (this.error ? `${this.error} et ` : '') + 'Format de données analyses (client) incorrect';
          }
        } else if (Array.isArray(raw)) {
          analysesData = raw;
        } else if (raw && Array.isArray(raw.results)) {
          analysesData = raw.results;
        } else {
          this.error = (this.error ? `${this.error} et ` : '') + 'Format de données analyses (équipe) incorrect';
        }

        this.totalAnalyses = analysesData.length;
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques:', error);
        this.error = 'Impossible de charger les statistiques.';
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    await refreshProfileFromApi();
    this.profileRevision += 1;
    this.fetchStats();
  },
};
</script>

<style scoped>
</style>
